export const MIN_ACCOUNT_AGE_FOR_CHANGELOG = 14;
